import { FC } from 'react';

import sizes from 'constants/sizes';

import { EncumbrancesExcelModalProvider } from './context/EncumbrancesExcelModalContext';
import EncumbrancesExcelModal from './index';

type Props = {
  /** Usado por App.js para el tamaño del diálogo Bootstrap */
  size?: string;
};

const EncumbrancesExcelModalWithProvider: FC<Props> = ({
  size = sizes.XL,
}) => (
  <EncumbrancesExcelModalProvider>
    <EncumbrancesExcelModal />
  </EncumbrancesExcelModalProvider>
);

export default EncumbrancesExcelModalWithProvider;
